import api from '../../services/api';

const findByRequestId = async (requestId) =>
    api.get({ type: 'user', service: `requests/${requestId}/history` })

export default {
    findByRequestId
}